export enum WorkflowPublishActionType {
  Publish = 'PUBLISH',
  Unpublish = 'UNPUBLISH',
  PublishLatestDraft = 'PUBLISH_LATEST_DRAFT',
}
